<template>
  <section
    id="feature"
    class="sections sections--parallax sections--parallax__f"
  >
    <v-container>
      <v-row class="mb-10">
        <v-col cols="12" sm="4">
          <div class="sections-box">
            <div class="sections--border">
              <span class="sections--title">Songket</span>
              <h2 class="sections--menu">Fitur</h2>
            </div>
          </div>
        </v-col>
        <v-col>
          Songket telah menjadi bagian dari kehidupan masyarakat Nusantara yang kehadirannya tak hanya menjadi seperangkat sandang. Teknik pembuatannya, tradisinya, dan juga inspirasi di baliknya membuat setiap helai songket  memiliki khasnya tersendiri.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" v-for="(feature, i) in data" :key="i">
          <v-card
            :to="`/feature/${i}`"
            flat
            class="features--card d-flex align-center justify-center"
            height="250"
          >
            <div class="text-center">
              <p
                class="
                  text-sm-h4
                  font-weight-bold
                  text-center
                  mb-10
                  text-uppercase
                "
              >
                <span>{{ feature.menu }}</span> <br />
                {{ feature.title }}
              </p>
              <p>
                <v-icon x-large color="white" class="mb-1">
                  {{ feature.icon }}
                </v-icon>
                <br />
                <span class="text-uppercase font-weight-bold">
                  {{ feature.tag }}
                </span>
              </p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Feature",
  data() {
    return {
      data: [
        {
          menu: "SONGKET SEBAGAI",
          title: "TEKNIK",
          icon: "mdi-format-quote-open",
          tag: "baca"
        },
        {
          menu: "ORNAMEN",
          title: "INSPIRASI",
          icon: "mdi-format-quote-open",
          tag: "baca"
        },
        {
          menu: "ORNAMEN",
          title: "TRADISI",
          icon: "mdi-format-quote-open",
          tag: "baca"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
